import type { FapsDoor } from "../lib/faps";
import { FapsAmount } from "../control/ui/FapsAmount";

/**
 * A form's footer when the balance is short: how far, and the ways to close the gap —
 * the chest (only while it is actually ready) and Premium. A bought pack is redeemed by
 * LINK (the operator sends one after a Patreon purchase), so there is no in-app code
 * door here. A refusal that offers nothing is a dead end; this one is the wallet's funnel.
 *
 * Lifted out of the wall's buy dialog on 2026-09-09 when the vault's "Expand for 👑N"
 * became the second place a short balance is answered — one footer, one set of doors,
 * so the two sinks cannot drift into two different promises.
 */
export function InsufficientFaps({
  needed,
  chestReady,
  onDoor,
}: {
  needed: number;
  chestReady: boolean;
  onDoor: (door: FapsDoor) => void;
}) {
  const doorClass =
    "rounded-lg border border-white/15 px-3 py-2 text-xs text-zinc-200 transition-colors hover:bg-white/10";
  return (
    <div className="mt-3 rounded-xl border border-[#f5c518]/30 bg-[#f5c518]/5 p-3">
      <p className="mb-2 text-sm text-zinc-200">
        You need <FapsAmount n={needed} className="font-semibold" /> more.
      </p>
      <div className="flex flex-wrap gap-2">
        {chestReady ? (
          <button type="button" onClick={() => onDoor("chest")} className={doorClass}>
            Open today's chest
          </button>
        ) : null}
        <button type="button" onClick={() => onDoor("premium")} className={doorClass}>
          Go Premium
        </button>
      </div>
    </div>
  );
}
